export default __webpack_public_path__ + "static/media/frame_2.2db89f8b.png";